import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ItemService } from '../item.service';

@Component({
  selector: 'cc-item-time',
  templateUrl: './item-time.component.html',
  styleUrls: ['./item-time.component.scss']
})
export class ItemTimeComponent implements OnInit, OnDestroy {
  @Input() form: FormGroup;

  constructor(private itemService: ItemService) {}

  ngOnInit() {
    this.itemService.addField(this.form, {
      time: ''
    });
  }

  ngOnDestroy(): void {
    this.form.removeControl('time');
  }
}
